import createModule from "../createModule"
import view from "./view"
import { size } from "lodash"
import { Creators as NotificationsCreators } from "modules/notifications/model"
import { getFilterOns, getAddedFilters, getChipSecuritiesIds } from "./selectors/filter"
import { getChips } from "./selectors/chips"
import { MODEL_METADATA_QUERY } from "resources/models"
import "./styles.scss"

export default createModule({
  view,
  externalProps: (state, props) => ({
    securitiesIds: getChipSecuritiesIds(state, props),
    accountId: state.global.selected.accountId,
  }),
  required: ["account", "accountId", "modelId", "selectedDate"],
  data: [{
    resource: "securityFinderSecuritiesDescriptors",
    url: ({ account, modelId, securitiesIds, selectedDate }) => {
      if (size(securitiesIds) === 0) {
        return null
      }

      return {
        url: `/api/${account}/m/${modelId}/securities/descriptors?date=${selectedDate}`,
        id: `securitiesDescriptors${account}${modelId}${selectedDate}${JSON.stringify(securitiesIds)}`,
        payload: { ids: securitiesIds },
      }
    },
  },
  MODEL_METADATA_QUERY,
  ],
  mapStateToProps: (state, props) => ({
    filterOns: getFilterOns(state, props),
    chips: getChips(state, props),
    addedFilters: getAddedFilters(state, props),
  }),
  actions: {
    addNotification: NotificationsCreators.add,
  },
})
